"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "modal-card",
    staticStyle: {
      width: "auto"
    }
  }, [_vm._m(0), _vm._v(" "), _vm.application ? _c("section", {
    staticClass: "modal-card-body"
  }, [_c("div", {
    staticClass: "application-details"
  }, [_c("div", {
    staticClass: "detail-section"
  }, [_c("h4", {
    staticClass: "detail-section-title"
  }, [_vm._v("\n          Informações da Prescrição\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "detail-grid"
  }, [_c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Nome:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.application.prescricao))])]), _vm._v(" "), _vm.application.prescricaoCategoria ? _c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Categoria:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.getCategoryLabel(_vm.application.prescricaoCategoria)))])]) : _vm._e(), _vm._v(" "), _vm.application.prescricaoDescricao ? _c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Descrição:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.application.prescricaoDescricao))])]) : _vm._e()])]), _vm._v(" "), _vm.application.prescricaoProductsDosage && _vm.application.prescricaoProductsDosage.length ? _c("div", {
    staticClass: "detail-section"
  }, [_c("h4", {
    staticClass: "detail-section-title"
  }, [_vm._v("\n          Produtos da Prescrição\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "products-table"
  }, [_vm._m(1), _vm._v(" "), _vm._l(_vm.application.prescricaoProductsDosage, function (product, index) {
    return _c("div", {
      key: index,
      staticClass: "table-row"
    }, [_c("span", {
      staticClass: "column-produto"
    }, [_vm._v(_vm._s(product.productName))]), _vm._v(" "), _c("span", {
      staticClass: "column-dose"
    }, [_vm._v(_vm._s(_vm.formatDosage(product)))])]);
  })], 2)]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "detail-section"
  }, [_c("h4", {
    staticClass: "detail-section-title"
  }, [_vm._v("\n          Status e Cronograma\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "detail-grid"
  }, [_c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Status:")]), _vm._v(" "), _c("span", {
    staticClass: "tag",
    class: _vm.getStatusType(_vm.application.status, _vm.application.dataAplicacao)
  }, [_vm._v(_vm._s(_vm.getStatusLabel(_vm.application.status, _vm.application.dataAplicacao)))])]), _vm._v(" "), _c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Data de Aplicação:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.formatDate(_vm.application.dataAplicacao)))])]), _vm._v(" "), _c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Período:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.application.periodoAplicacao))])])])]), _vm._v(" "), _c("div", {
    staticClass: "detail-section"
  }, [_c("h4", {
    staticClass: "detail-section-title"
  }, [_vm._v("\n          Localização e Recursos\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "detail-grid"
  }, [_c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Local:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.application.local))])]), _vm._v(" "), _vm.application.aplicador !== "--" ? _c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Coordenador:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.application.aplicador))])]) : _vm._e(), _vm._v(" "), _vm.application.equipamento !== "--" ? _c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Equipamento:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.application.equipamento))])]) : _vm._e(), _vm._v(" "), _vm.application.tempoTrabalho !== "--" ? _c("div", {
    staticClass: "detail-item"
  }, [_c("strong", [_vm._v("Tempo de Trabalho:")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.application.tempoTrabalho))])]) : _vm._e()])]), _vm._v(" "), _vm.application.description ? _c("div", {
    staticClass: "detail-section"
  }, [_c("h4", {
    staticClass: "detail-section-title"
  }, [_vm._v("\n          Descrição\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "detail-content"
  }, [_c("p", [_vm._v(_vm._s(_vm.application.description))])])]) : _vm._e(), _vm._v(" "), _vm.application.observation ? _c("div", {
    staticClass: "detail-section"
  }, [_c("h4", {
    staticClass: "detail-section-title"
  }, [_vm._v("\n          Observações\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "detail-content"
  }, [_c("p", [_vm._v(_vm._s(_vm.application.observation))])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.application ? _c("footer", {
    staticClass: "modal-card-foot"
  }, [_vm.application.status === "PENDING" ? _c("b-button", {
    attrs: {
      type: "is-success"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("start-application", _vm.application);
      }
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "play",
      size: "is-small"
    }
  }), _vm._v("\n      Iniciar aplicação\n    ")], 1) : _vm._e(), _vm._v(" "), _vm.application.status === "IN_PROGRESS" ? _c("b-button", {
    attrs: {
      type: "is-warning"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("update-status", _vm.application);
      }
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "refresh",
      size: "is-small"
    }
  }), _vm._v("\n      Atualizar Status\n    ")], 1) : _vm._e(), _vm._v(" "), _vm.application.status === "PAUSED" ? _c("b-button", {
    attrs: {
      type: "is-info"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("resume-application", _vm.application);
      }
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "play",
      size: "is-small"
    }
  }), _vm._v("\n      Retomar aplicação\n    ")], 1) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_c("i", {
    staticClass: "fas fa-info-circle"
  }), _vm._v("\n      Detalhes da Aplicação\n    ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-header"
  }, [_c("span", {
    staticClass: "column-produto"
  }, [_vm._v("Produto")]), _vm._v(" "), _c("span", {
    staticClass: "column-dose"
  }, [_vm._v("Dose")])]);
}];
render._withStripped = true;